import { ConstantsTableColsEmissionsquelle } from "./constants-table-cols-emissionsquelle";

export class ConstantsTableColsFlaeche extends ConstantsTableColsEmissionsquelle {
  static readonly EMISSIONSMINDERUNGSMASSNAHME: string =
    'EMISSIONSMINDERUNGSMASSNAHME';
  static readonly WIRKUNGSGRAD: string = 'WIRKUNGSGRAD';
  static readonly LAENGE_HOEHE: string = 'LAENGE_HOEHE';
  static readonly BREITE: string = 'BREITE';
  static readonly DURCHMESSER: string = 'DURCHMESSER';
  static readonly FLAECHE: string = 'FLAECHE';
  static readonly FLAECHENQUELLART: string = 'FLAECHENQUELLART';
  static readonly EMISSIONSFAKTOR_GE_GV: string = 'EMISSIONSFAKTOR_GE_GV';

  public static getColumns(): string[] {
    return [
      this.EDIT_REMOVE,
      this.BEZEICHNUNG,
      this.FLAECHENQUELLART,
      this.DURCHMESSER,
      this.LAENGE_HOEHE,
      this.BREITE,
      this.FLAECHE,
      this.EMISSIONSFAKTOR_GE_GV,
      this.EMISSIONSMINDERUNGSMASSNAHME,
      this.WIRKUNGSGRAD,
      this.GEWICHTUNGSFAKTOR,
      this.EMISSION_GE,
      this.X_KOORDINATE,
      this.Y_KOORDINATE
      
    ];
  }


}
